import { createDefaultText } from './text';
import type { TabElement, TabOptions, TextProps } from '../types';

export function createTabElement(
  textStyles: Partial<TextProps>,
  defaultTabOptions?: TabOptions
): TabElement {
  return {
    children: [createDefaultText(textStyles)],
    options: defaultTabOptions,
    suggestedEdits: [],
    type: 'tab',
  };
}
